import api from './api';
import { resetAiNudges } from './aiNudge';

/**
 * The single choke point for changing AI personalization consent.
 *
 * Every change — granted from a nudge, from first-run, or paused in Settings —
 * clears the nudge flags. A pause is a fresh decision and must not inherit the
 * silence left by an ask from the *previous* time AI was on; otherwise the app
 * goes permanently quiet about being off, and the only way back is finding the
 * setting yourself.
 *
 * Mirrors mobile's ProfileRepository.setAiConsent.
 *
 * @param {string} userId
 * @param {{accepted: boolean, clearMemory?: boolean}} opts
 *   `clearMemory` only means anything when pausing: true erases what the AI has
 *   learned, false keeps it so a later re-grant resumes. Omitted when granting.
 */
export async function setAiConsent(userId, { accepted, clearMemory }) {
  await api.post(`/user/${userId}/ai-consent`, {
    accepted,
    ...(accepted ? {} : { clearMemory: clearMemory ?? true }),
  });
  resetAiNudges();
}
